import * as React from 'react';
import { observer, inject } from 'mobx-react';
import {observable, action, computed} from 'mobx';
import { Grid, TextField, Button, Dialog, DialogTitle, DialogContent, DialogActions, InputAdornment, List, ListItem, ListItemText, Typography, MenuItem, Switch, Checkbox, FormControlLabel } from '@material-ui/core';
import AuthStore from 'src/stores/AuthStore';
import KlientStore from 'src/stores/KlientStore';
import SearchIcon from '@material-ui/icons/Search';
import Klient from 'src/models/Klient';
import { DatePicker } from 'material-ui-pickers';
import moment from 'moment';
import TurnusStore from 'src/stores/TurnusStore';
import Turnus from 'src/models/Turnus';
import CiselnikyStore from 'src/stores/CiselnikyStore';

export interface ITurnusNewDialogProps {
    open;
    onClose;
    onAdd;
    ciselnikyStore?: CiselnikyStore;
}

@inject('ciselnikyStore')
@observer
class TurnusNewDialog extends React.Component<ITurnusNewDialogProps>{

    @action
    private handleChange = name => event => {
        this[name] = event.target.value;
    }

    @action
    private handleCheckedChange = (name, checked, unchecked) => event => {
        this[name] = event.target.checked ? checked : unchecked;
    };

    @action
    private handleTurnusFromChange = date => {
        this.newTurnusFrom = moment(date).toDate();
    }
    
    private disableAllButMonday = date => {
        return moment(date).toDate().getDay() !== 1;
    }

    private doOnAdd = () => {
        const turnus: Turnus = new Turnus();
        turnus.od = this.newTurnusFrom;
        turnus.do = this.newTurnusTo;
        turnus.program = this.newTurnusProgram;
        turnus.rozsah = [];
        if(this.newTurnusPlny) {
            turnus.rozsah.push('plny');
        } else {
            if(this.newTurnusMenuSnidane) {
                turnus.rozsah.push('snidane');
            }
            if(this.newTurnusMenuSvacina1) {
                turnus.rozsah.push('svacina1');
            }
            if(this.newTurnusMenuObed) {
                turnus.rozsah.push('obed');
            }
            if(this.newTurnusMenuSvacina2) {
                turnus.rozsah.push('svacina2');
            }
            if(this.newTurnusMenuVecere) {
                turnus.rozsah.push('vecere');
            }
        }
        this.props.onAdd(turnus);
        this.reset();
    }

    private doOnClose = () => {
        this.props.onClose();
        this.reset();
    }

    private reset = () => {
        this.newTurnusFrom = moment().day(1).toDate();
        this.newTurnusProgram = this.props.ciselnikyStore.getLatestValidProgramByValue(5000).id;
        this.newTurnusWeeks = 4;
        this.newTurnusPlny = true;
        this.newTurnusMenuSnidane = false;
        this.newTurnusMenuSvacina1 = false;
        this.newTurnusMenuObed = false;
        this.newTurnusMenuSvacina2 = false;
        this.newTurnusMenuVecere = false;
    }

    private useDefaultPrice: boolean = true;

    @observable private newTurnusFrom: Date = moment().day(1).toDate();
    @observable private newTurnusProgram: number = this.props.ciselnikyStore.getLatestValidProgramByValue(5000).id;
    @observable private newTurnusWeeks: number = 4;
    @observable private newTurnusPlny: boolean = true;
    @observable private newTurnusMenuSnidane: boolean = false;
    @observable private newTurnusMenuSvacina1: boolean = false;
    @observable private newTurnusMenuObed: boolean = false;
    @observable private newTurnusMenuSvacina2: boolean = false;
    @observable private newTurnusMenuVecere: boolean = false;

    @computed private get newTurnusTo(): Date {
        return moment(this.newTurnusFrom).add(this.newTurnusWeeks-1, 'w').add(4, 'd').toDate();
    }

    public render() {
        return (
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Nový turnus</DialogTitle>
                <DialogContent>
                        <Grid container spacing={8}>
                            <Grid item>
                                <DatePicker label="Počáteční datum" value={this.newTurnusFrom} onChange={this.handleTurnusFromChange} shouldDisableDate={this.disableAllButMonday}/>
                            </Grid>
                            <Grid item>
                                <TextField label="Délka v týdnech" type="number" value={this.newTurnusWeeks} 
                                    onChange={this.handleChange('newTurnusWeeks')} />
                            </Grid>
                            <Grid item>
                                <TextField style={{marginRight: '15px'}} label="Program" id="new-turnus-program" select onChange={this.handleChange('newTurnusProgram')} 
                                    value={this.newTurnusProgram}>
                                        {this.props.ciselnikyStore.getAllValidPrograms().map(prg => (
                                            <MenuItem value={prg.id}>{prg.value} kJ ({prg.price} Kč/den)</MenuItem>
                                        ))}
                                </TextField>
                                Plné menu: <Switch checked={this.newTurnusPlny} onChange={this.handleCheckedChange('newTurnusPlny', true, false)} />
                            </Grid>
                            {this.newTurnusPlny?'':(
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={this.newTurnusMenuSnidane} onChange={this.handleCheckedChange('newTurnusMenuSnidane', true, false)} />
                                    }
                                    label="Snídaně"
                                    />
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={this.newTurnusMenuSvacina1} onChange={this.handleCheckedChange('newTurnusMenuSvacina1', true, false)} />
                                    }
                                    label="Svačina 1"
                                    />
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={this.newTurnusMenuObed} onChange={this.handleCheckedChange('newTurnusMenuObed', true, false)} />
                                    }
                                    label="Oběd"
                                    />
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={this.newTurnusMenuSvacina2} onChange={this.handleCheckedChange('newTurnusMenuSvacina2', true, false)} />
                                    }
                                    label="Svačina 2"
                                    />
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={this.newTurnusMenuVecere} onChange={this.handleCheckedChange('newTurnusMenuVecere', true, false)} />
                                    }
                                    label="Večeře"
                                    />
                            </Grid>)}
                        </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.doOnClose} color="primary">
                        Storno
                    </Button>
                    <Button onClick={this.doOnAdd} color="primary">
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default TurnusNewDialog;



// WEBPACK FOOTER //
// ./src/components/TurnusNewDialog.tsx